import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (import.meta.env.DEV) {
  console.log('🔧 Supabase config check:', {
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey,
    urlPreview: supabaseUrl ? supabaseUrl.substring(0, 20) + '...' : 'missing',
    keyPreview: supabaseAnonKey ? supabaseAnonKey.substring(0, 10) + '...' : 'missing'
  });
}

// Create Supabase client with fallback for missing env vars
let supabase: ReturnType<typeof createClient> | null = null;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase environment variables missing. Database features will be disabled.');
  console.warn('Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to enable database features.');
  supabase = null;
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
}

export { supabase };

if (supabase) {
  if (import.meta.env.DEV) {
    console.log('✅ Supabase client initialized successfully');
  }
  // Test connection
  supabase.auth.getSession().then(({ data, error }) => {
    if (error) {
      console.warn('⚠️ Supabase connection test failed:', error.message);
    } else {
      if (import.meta.env.DEV) {
        console.log('✅ Supabase connection test passed');
      }
    }
  });
} else {
  if (import.meta.env.DEV) {
    console.log('⚠️ Supabase client not initialized - running without database features');
  }
}

// Helper functions for type safety
export const Tables = {
  USERS: 'users',
  READINGS: 'readings',
  STREAKS: 'streaks',
  APP_SETTINGS: 'app_settings',
} as const; 